import * as React from 'react';
import { connect } from 'react-redux';
import GlobalSearchResultsList from 'components/GlobalSearchResultsList';
import type { GlobalSearchProps } from './GlobalSearch.types';

class GlobalSearch extends React.Component<GlobalSearchProps, null> {
  render() {
    const {
      match: {
        params: { term },
      },
    } = this.props;
    return <GlobalSearchResultsList term={term} />;
  }
}

export default connect(null, null)(GlobalSearch);
